import { func } from 'prop-types';
import React from 'react';

import Button from '../../components/Button';

import s from './index.module.css';

const Footer = ({ onBtnClick }) => {
  return (
    <section className={s.footerSection}>
      <h2 className={s.footerHeader}>Помогаем магазинам автозапчастей увеличить продажи</h2>
      <div className={s.footerContent}>
        <p className={s.info}>
          Загружайте свои предложения на Смартби и получайте готовые заказы от розничных покупателей со средним чеком в 3 599 ₽.
        </p>
        <Button className={s.submitBtn} type="button" onClick={onBtnClick}>Подключить магазин</Button>
      </div>
    </section>
  );
}

Footer.propTypes = {
  onBtnClick: func,
};

Footer.defaultProps = {
  onBtnClick: () => {},
};

export default Footer;


